import React, { useCallback, useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import { TournamentModalImages } from './tournament-modal-images';
import { useStore, useTranslation } from '../../../../hooks';
import { GameRedirectionSource } from '../../../../enums';
import { integration } from '../../../../services';
import { T } from '../../../../constants';


interface TournamentFinishedModalProps {

}

export const TournamentFinishedModal: React.FC<TournamentFinishedModalProps> = observer(() => {

  const { gameStore, tournamentStore } = useStore();
  const { launchData: { data: launchData } } = gameStore;
  const { tournamentUserStat: { data: tournamentUserStat } } = tournamentStore;

  const t = useTranslation();

  useEffect(() => {
    if (launchData) {
      tournamentStore.getTournamentUserStat(launchData.tournamentId as number);
    }
  }, []);

  const onRealModeClick = useCallback(() => {
    if (!launchData) return;
    integration.current.changeGame({ gameId: launchData?.gameId, source: GameRedirectionSource.Tournament });
  }, [launchData]);

  const onSeeDetailsClick = useCallback(() => {
    tournamentStore.setTournamentFinishedModalOpen(false);
    tournamentStore.openTournamentFrame(launchData?.tournamentId);
  }, []);

  return (
    <div className="tournament-popup-layer finished">
      <div className="tournament-popup-wrapper tournament-finished-popup">

        <div className="tournament-popup-top-img"></div>

        <div className="tournament-popup-game-wrapper">
          <div className="score-block">
            <p className="score-block-txt">{t(T.SCORE)}</p>
          </div>
          <div className="score-block-number">
            <p className="score-block-number-txt font-speedrush">
              {tournamentUserStat.score}
            </p>
          </div>
          <div className="rank-block">
            <p className="rank-block-txt">{t(T.YOUR_RANK)}</p>
            <div className="rank-block-number">
              <span className="rank-block-number-txt font-speedrush">
                {tournamentUserStat.rank}
              </span>
            </div>
          </div>
          <div className="more-info-btn-wrapper">
            <button className="tournament-game-btn" onClick={onRealModeClick}>{t(T.REAL_MODE)}</button>
            <button className="see-details-bnt" onClick={onSeeDetailsClick}>{t(T.SEE_DETAILS)}</button>
          </div>
        </div>

        <TournamentModalImages />

      </div>
    </div>
  );
});
